import { gql, useQuery } from '@apollo/client'


export interface FetchCatalogStats {
  catalogStats: {
    total: number
    totalActive: number
    totalNew: number
    totalBoughtCount: number
  }
}

export const GQL_QUERY_FETCH_CATALOG_STATS = gql`
  query catalogStats {
    catalogStats {
      total
      totalActive
      totalNew
      totalBoughtCount
    }
  }
`

export const useQueryCatalogStats = () => {
  return useQuery<FetchCatalogStats>(GQL_QUERY_FETCH_CATALOG_STATS, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first'
  })
}
